/**
 * The chat the user was in, per account, so leaving /chat and coming back
 * (or refreshing) reopens it instead of starting an empty one. The chat page
 * writes it; the chat activity provider reads it to tell whether a finished
 * reply is the one already on screen.
 */
export const savedConversationKey = (userId: string) => `x11-chat-conversation:${userId}`

export function isConversationId(value: string | null | undefined): value is string {
  return Boolean(value && /^[a-f0-9]{24}$/i.test(value))
}

export function readSavedConversation(userId: string): string | null {
  try {
    const id = localStorage.getItem(savedConversationKey(userId))
    return isConversationId(id) ? id : null
  } catch {
    return null
  }
}
